import React from 'react';
import { Target, Users, Lightbulb } from 'lucide-react';
import { aboutImages } from '../utils/mockData';

export const AboutSection = () => {
  return (
    <section id="tentang" className="py-20 scroll-mt-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white">
              Tentang Dreams Marketing
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-400 leading-relaxed">
              Dreams Marketing adalah agensi digital marketing yang menyediakan layanan lengkap untuk membantu bisnis dan individu berkembang di era digital.
            </p>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <Target className="w-6 h-6 text-[#D32F2F] flex-shrink-0 mt-0.5" />
                <div>
                  <h4 className="font-semibold text-gray-900 dark:text-white mb-1">Fokus Kualitas</h4>
                  <p className="text-gray-600 dark:text-gray-400">Setiap strategi dirancang dengan detail untuk hasil maksimal</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Lightbulb className="w-6 h-6 text-[#D32F2F] flex-shrink-0 mt-0.5" />
                <div>
                  <h4 className="font-semibold text-gray-900 dark:text-white mb-1">Strategi Berbasis Data</h4>
                  <p className="text-gray-600 dark:text-gray-400">Menggunakan insights dan analytics untuk keputusan tepat</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Users className="w-6 h-6 text-[#D32F2F] flex-shrink-0 mt-0.5" />
                <div>
                  <h4 className="font-semibold text-gray-900 dark:text-white mb-1">Pendampingan Edukasi</h4>
                  <p className="text-gray-600 dark:text-gray-400">Tidak hanya eksekusi, tapi juga pemberdayaan skill digital</p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative">
            <img
              src={aboutImages.workspace}
              alt="Dreams Marketing Workspace"
              className="rounded-2xl shadow-2xl w-full h-auto object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
